"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetDetailImage = void 0;
var AssetDetailImage_1 = require("./AssetDetailImage");
Object.defineProperty(exports, "AssetDetailImage", { enumerable: true, get: function () { return AssetDetailImage_1.AssetDetailImage; } });
